<template>
  <div class="p-3 bg-white">
    <shared-auto-call-system-upload-data
      @uploadSuccess="uploadSuccess"
    ></shared-auto-call-system-upload-data>

    <div class="text-right">
      <vs-button id="uploadButton" class="m-2" color="primary" type="filled" @click.prevent="upload">{{ $t('upload') }}</vs-button>
    </div>
    <br/>
    <vs-button class="m-2" color="success" type="filled" @click.prevent="downloadSample">{{ $t('download_sample') }}</vs-button>
  </div>
</template>

<script>
import SharedAutoCallSystemUploadData from '@/views/Shared/AutoCallSystem/UploadData'
import { EventBus } from '@/../eventbus.js'
import AutoCallSystem from '@/models/AutoCallSystem'

export default {
  name: 'Window.AutoCallSystem.Upload',
  components: {
    SharedAutoCallSystemUploadData
  },
  methods: {
    upload () {
      EventBus.$emit('initUploadAutoCallSystemData')
    },
    async downloadSample (e) {
      e.preventDefault()
      try {
        this.language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
        await AutoCallSystem.downloadSampleImportFile(this.language)
      } catch (e) {
        this.$alertHelper.error()
      }
    },
    uploadSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_auto_call_system_table')
      window.close()
    },
    cancel () {
      this.$windowOpenerHelper.notifyOpener('reload_auto_call_system_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
